/**
 * @returns a correctly formatted query string to provide to the "getExternalAccounts" fetcher.
 * @example
 * Sample input1: {
 *    planIds: [1]
 *    accountProvider: 'manual'
 * }
 * Sample output1: "?planId=1&accountProvider=manual"
 *
 * Sample input2: {
 *    taskIds: [1,2,3]
 *    planIds: [1]
 * }
 * Sample output2: "?planId=1&taskId=1&taskId=2&taskId=3"
 */
const buildExternalAccountsQuery = (params) => {
    if (params === undefined) {
        return "";
    }
    const param = new URLSearchParams();
    const { planIds, taskIds, accountProvider, includeAttachment } = params;
    if (planIds) {
        planIds.forEach((id) => param.append("planId", id));
    }
    if (taskIds) {
        taskIds.forEach((id) => param.append("taskId", id));
    }
    if (accountProvider !== undefined) {
        param.append("accountProvider", accountProvider);
    }
    if (includeAttachment === true) {
        param.append("includeAttachment", "true");
    }
    const q = param.toString();
    return q.length === 0 ? "" : `?${q}`;
};
export default buildExternalAccountsQuery;
//# sourceMappingURL=buildExternalAccountsQuery.js.map